import { NgForm } from '@angular/forms';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Creative } from '../../../interfaces/adservices';

@Component({
	selector: 'vast-details-endscreen',
	templateUrl: './vast-details-endscreen.component.html',
	styleUrls: ['./vast-details-endscreen.component.scss']
})


export class VastDetailsEndscreenComponent implements OnInit, OnChanges {
	@Input() creative: Creative;
	@Input() form: NgForm;

	asset: string;

	constructor() {
		this.asset = 'https://d3mxuwgars1eqe.cloudfront.net/media/2017/06/14/asset-1081219-1497451655638116.mp4?cb=1504775720212aa';
	}

	ngOnInit() {
		if (this.creative) {
			this.initCreative();
		}
	}

	thumbnailsChanged(thumbnails: any[]) {
		this.creative.thumbnails = thumbnails;
		this.form.form.markAsDirty();
	}

	ngOnChanges(changesObj: SimpleChanges) {
		if (changesObj) { }
		// for (var key in changesObj) {

		// 	if (key == 'creative' && this.creative) {
		// 		initCreative();
		// 	}
		// }
	}

	initCreative() {
		if (!this.creative || !this.creative.assets || !this.creative.assets.length) {
			return '';
		}

		const filteredAssets: any[] = [];

		this.creative.assets.forEach((asset: any) => {
			if (asset.mediatype && asset.mediatype.indexOf('MP4_') !== -1 && asset.mediatype.indexOf('HLS') === -1) {
				filteredAssets.push(asset);
			}
		});
		filteredAssets.sort((a, b) => Number(b.bandwidth - a.bandwidth));

		this.asset = filteredAssets[0].src;
	}
}
